export const LogLevel = {
  info: 1,
  debug: 2,
  warn: 4,
  error: 8
}

export const LogType = {
  toast: 'toast',            // log 提示信息，一般是程序没有按照预想执行的提示信息；比如因为账号或者密码输错导致的login_fail
  event: 'event',            // log 用户事件，如注册，登录，预约...
  error: 'error',            // log 网络接口错误 或者 catch到的异常
  pageView: 'pageView',      // log 页面访问情况
  network: 'network'         // log 网络接口执行情况
}

export default class BaseLog {
  flushing = false;
  cacheLogs = [];
  _tmpLogs = [];
  _pageViews = [];
  logUrl = '';
  isDebug = true;

  constructor(common, logUrl, isDebug) {
    this.common = common;
    this.logUrl = logUrl;
    this.isDebug = isDebug;
    this.flushingLogs();
  }

  logPrint(...data) {
    this.isDebug && console.log('[LOG] => ', ...data);
  }

  async uploads() {
    if (this.flushing) { return; }

    if (this.cacheLogs.length) {
      try {
        this.flushing = true;
        const curLogs = this.cacheLogs.slice(0);
        this.cacheLogs.length = 0;
        await this.uploadAsync(curLogs);
        this.flushing = false;

        if (this._tmpLogs.length) {
          let tmpLogs = this._tmpLogs.slice(0);
          this._tmpLogs.length = 0;
          await this.uploadAsync(tmpLogs);
        }
      } catch (err) {
        this.flushing = false;
        this.logPrint(err);
      }
    }
  }

  async save(stat) {
    try {
      let st = {
        ...this.common,
        ...stat,
        tm: Date.now(),
        utc_tm: (new Date()).toISOString()
      };
      // collect pageView when leave page, for calculate the page persistence time
      if (st.lt && st.lt === LogType.pageView) {
        if (this._pageViews.length === 0) {
          this._pageViews.push(st);
          return;
        } else {
          const curStat = this._pageViews.pop();
          if (curStat.spma === st.spma) {
            this._pageViews.push(Object.assign({}, curStat, st));
            return;
          } else {
            this._pageViews.push(Object.assign({}, st));
            curStat.leave = Date.now();
            st = curStat;
          }
        }
      }
      if (this.flushing) {
        this._tmpLogs.push(st);
      } else {
        this.cacheLogs.push(st);
      }
      this.logPrint(`[${st.lt}]`, st);
    } catch (err) {
      //todo: maybe upload to firebase
      this.logPrint(err);
    }
  }

  flushingLogs() {
    const self = this;
    async function loopUpload() {
      self.uploads();
      setTimeout(loopUpload, 1000);
    }
    loopUpload();
  }

  async uploadAsync(records) {
    const self = this;
    async function upload(url, log) {
      await fetch(url, {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          writeMongo: false,
          level: log.lt === LogType.error ? LogLevel.error : LogLevel.info,
          message: '',
          catalog: log.lt,
          ClientIP: '',
          AdditionalInfo: log
        }),
      }).then((response) => {
        if (response.ok) {
          return response.json()
        } else {
          return response.text()
        }
      }).then((result) => {
        self.logPrint(url, result)
      }).catch((error) => {
        self.logPrint(url, error)
      });
    }

    this.logUrl && records.forEach((log) => {
      upload(this.logUrl, log)
    })
  }

  /**
   * convert object to string like key1=val1`key2=val2
   * @param {Object} objStat
   */
  toString(objStat) {
    return Object.keys(objStat).reduce((result, key) => {
      if (typeof objStat[key] === 'string') {
        result += `${key}=${objStat[key]}\``
      } else {
        result += `${key}=${JSON.stringify(objStat[key])}\``;
      }
      return result;
    }, '');
  }
}
